import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import HelloTradePage from "../Pages/HelloTradePage";
import HomePage from "../BureauJourney/HomePage";
import BureauReportForm from "../HelloTrade/BureauReport";
import BenefitsComponent from "../BureauJourney/Components/BenefitsComponent";
import AppTest from "../Pages/AppTest";
export default function RouterComponent(){
    return(
        <Router>
            <Routes>
                <Route path = "/" element={<HelloTradePage/>}/>
                <Route path = "/apply" element={<HomePage/>}/>
                <Route path = "/downloadReport" element={<BureauReportForm/>}/>
                <Route path = "benefit" element={<BenefitsComponent/>}/>
                <Route path = "/appTest" element={<AppTest/>}/>
            </Routes>
        </Router>
    )
}

